import type { Theme } from '@mui/material/styles';

const Slider = (theme: Theme) => {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiSlider: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        markLabel: {
          color: theme.palette.text.disabled,
          fontSize: 13,
        },
        rail: {
          opacity: 0.32,
        },
        root: {
          '&.Mui-disabled': {
            color: theme.palette.action.disabled,
          },
        },
        valueLabel: {
          backgroundColor: theme.palette.grey[isLight ? 800 : 700],
          borderRadius: 8,
        },
      },
    },
  };
};

export default Slider;
